import React, { useEffect } from 'react'
import { ScrollView, TouchableHighlight } from 'react-native'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { CustomHeader } from '../../components/CustomHeader'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { logout } from '../../utils/logout'
import { atlTheme } from '../../atlTheme'
import {
  ATLAtomIcon,
  ATLIconizedText,
  ATLSpacing,
  ATLTextHead,
  SpacingSizesEnum,
  TextAlignmentEnum,
} from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import styled from 'styled-components/native'
import { ProfilePersonalInfo } from './ProfilePersonalInfo'
import { ProfileNavigationItem } from './ProfileNavigationItem'
import { ActivateNotifications } from './ActivateNotifications'
import { usePromise } from '../../utils/hooks/usePromise'
import { getCurrentUser } from '../../services/main/getCurrentUser'
import { useGlobal } from '../../global/useGlobal'
import { Loading } from '../../components/loading/Loading'
import { Container } from './ItemContainer'
import { GenericInfoScreenContext } from './constants'

const ProfileContainer = styled.SafeAreaView`
  flex: 1;
`

export const ProfileScreen: NavigationStackScreenComponent = () => {
  const [currentUser] = useGlobal('currentUserInfo')
  const [dropdownUserSaleContractsData] = useGlobal('dropdownUserSaleContractsData')
  const { request: fetchCurrentUser, loading: isFetchingCurrentUser } = usePromise(getCurrentUser, [], {})

  useEffect(() => {
    fetchCurrentUser()
  }, [])

  const goToAboutScreen = () => {
    Coordinator.goToGenericInfoScreen(GenericInfoScreenContext.ABOUT, false)
  }
  const goToPrivacyPolicyScreen = () => {
    Coordinator.goToGenericInfoScreen(GenericInfoScreenContext.PRIVACY_POLICY, false)
  }
  const goToUseTermsScreen = () => {
    Coordinator.goToGenericInfoScreen(GenericInfoScreenContext.USE_TERMS, false)
  }

  return (
    <ProfileContainer>
      {isFetchingCurrentUser ? (
        <>
          <ATLSpacing type={SpacingSizesEnum.marginal} />
          <Loading />
        </>
      ) : (
        <ScrollView>
          <ProfilePersonalInfo
            name={currentUser?.nickname || currentUser?.name}
            email={currentUser?.email}
            cpf={currentUser?.cpf}
          />

          <Container>
            <ATLTextHead textAlignment={TextAlignmentEnum.left}>
              {formatMessage(messages.profileScreen_enterpriseLabel)}
            </ATLTextHead>
            <>
              {dropdownUserSaleContractsData?.map(item => {
                return (
                  <ATLIconizedText
                    key={item.id}
                    icon={icons.home}
                    text={item.text}
                    horizontalPadding={atlTheme.SpacingMarginal}
                  />
                )
              })}
            </>
          </Container>

          <ProfileNavigationItem
            text={formatMessage(messages.profileScreen_changePassword)}
            onPress={Coordinator.goToChangePasswordScreen}
            icon={icons.openLock}
          />
          <ProfileNavigationItem
            text={formatMessage(messages.profileScreen_aboutBrio)}
            onPress={goToAboutScreen}
            icon={icons.about}
          />
          <ProfileNavigationItem
            text={formatMessage(messages.profileScreen_privacyPolicy)}
            onPress={goToPrivacyPolicyScreen}
            icon={icons.privacy}
          />
          <ProfileNavigationItem
            text={formatMessage(messages.profileScreen_useTerms)}
            onPress={goToUseTermsScreen}
            icon={icons.mobilePhone}
          />
          <ActivateNotifications isPushEnabled={currentUser?.isPushEnabled} />
          <ATLSpacing type={SpacingSizesEnum.intersection} />
        </ScrollView>
      )}
    </ProfileContainer>
  )
}

ProfileScreen.navigationOptions = {
  ...CustomHeader(formatMessage(messages.profileScreen_headerTitle_label), true, () => Coordinator.goBack()),
  headerRight: () => (
    <TouchableHighlight
      onPress={logout}
      underlayColor={'transparent'}
      style={{ marginRight: atlTheme.SpacingMarginal }}
    >
      <ATLAtomIcon source={icons.logout} size={atlTheme.SizeIconBase} />
    </TouchableHighlight>
  ),
}
